import { useEffect } from 'react';
import './RepaymentSchedule.css';
import { getViewDocumentUrl } from '../../utils/docUtils';
import { BsArrowUpRight, BsEye } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useMediaViewer } from '../MediaViewerModal/useMediaViewer';

const RepaymentSchedule = ({ repaymentSchedule, tranche }) => {
    const navigate = useNavigate();
    const { openMedia, MediaViewer } = useMediaViewer();

    return (
        <div>
            {MediaViewer}
            {
                repaymentSchedule.length === 0 ? (
                    <p>Repayment Schedule Not Yet Generated</p>
                ) : (
                    <div className="RepaymentScheduleTableContainer">
                        <table className="rs-table">
                            <thead>
                                <tr>
                                    <th>EMI Number</th>
                                    <th>Due Date</th>
                                    <th>Payment Date</th>
                                    <th>No. of days</th>
                                    <th>EMI Amount</th>
                                    <th>Principal Component</th>
                                    <th>Interest Component</th>
                                    <th>Total Payment Adjusted</th>
                                    <th>Principal Adjusted</th>
                                    <th>Interest Adjusted</th>
                                    <th>Outstanding Principal</th>
                                    <th>Outstanding Interest</th>
                                    <th>Late Charge</th>
                                    <th>Payment Status</th>
                                    <th>Tranche ID</th>
                                    <th>Purchase Bill</th>
                                </tr>
                            </thead>
                            <tbody>
                                {repaymentSchedule?.map((schedule, index) => (
                                    <tr key={index}>
                                        <td>{schedule?.emi_number}</td>
                                        <td>{schedule?.due_date}</td>
                                        <td>{schedule?.payment_date}</td>
                                        <td>{schedule?.no_of_days}</td>
                                        <td>{schedule?.emi_amount}</td>
                                        <td>{schedule?.principal_component}</td>
                                        <td>{schedule?.interest_component}</td>
                                        <td>{schedule?.total_payment_adjusted}</td>
                                        <td>{schedule?.principal_adjusted}</td>
                                        <td>{schedule?.interest_adjusted}</td>
                                        <td>{schedule?.outstanding_principal}</td>
                                        <td>{schedule?.outstanding_interest}</td>
                                        {/* <td>{schedule?.late_charge?.total_late_charge}</td> */}
                                        <td>{schedule?.late_charge?.[0]?.amount}</td>
                                        <td>
                                            <span className={`leadStatusBadge status-${schedule?.payment_status?.toLowerCase()?.replace('_', '-')}`}>
                                                <span className="statusDot"></span>
                                                {schedule?.payment_status?.toUpperCase()?.split("_").join(" ")}
                                            </span>
                                        </td>
                                        <td>{schedule?.tranche_id}</td>
                                        <td 
                                            className='view-link'
                                            onClick={async (e) => {
                                                e.stopPropagation(); // prevents triggering row click if inside a table row
                                                let fetchedDocument = await getViewDocumentUrl(tranche?.document);

                                                if (fetchedDocument?.document_url) {
                                                    openMedia(fetchedDocument?.document_url);
                                                } else {
                                                    toast.error("No document URL found");
                                                }
                                            }}
                                        >
                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                <BsEye size={14} />
                                                View
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
            }
        
            {/* <div className="paginationControls">
                <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </div> */}
        </div>
    )
}

export default RepaymentSchedule